// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-user-template-confirm #group-name,#other-user-template-confirm #opening-sentence,#other-user-template-confirm #questions{white-space:pre-wrap;word-wrap:break-word}#other-user-template-confirm .back-btn,#other-user-template-confirm .register-btn{min-width:84px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
